// =============================================================================
// src/features/briefing/index.ts — Barrel da feature "Briefing do dia".
//
// Proveniencia: criado na reforma institucional 2026-06 (D2): o Briefing e a
//   NOVA landing do produto (resolveLandingView em src/app/landing-view.ts
//   decide; deep-links ?view= preservados). initBriefing publica o singleton
//   em window.BriefingRoute (contrato routeSingletonByName da topbar), liga os
//   CTAs e abre a rota quando for a landing.
// =============================================================================

import type { AppContext } from '../../app/types';
import { qs } from '../../app/dom';
import { getTopbarNav } from '../explore/explore-globals';
import { BriefingRoute } from './briefing-route';

export { buildBriefingPageMarkup } from './briefing-markup';
export { BriefingRoute } from './briefing-route';

/** Janela com o singleton que a feature publica (contrato da topbar). */
interface BriefingPublishWindow {
  BriefingRoute?: typeof BriefingRoute;
}

/**
 * Inicializa a feature Briefing: publica o singleton, resolve a pagina, liga os
 * CTAs e abre como landing quando openAsLanding=true (decidido por main.ts via
 * resolveLandingView).
 *
 * @example
 *   initBriefing(context, resolveLandingView(location.search) === 'briefing');
 */
export function initBriefing(ctx: AppContext, openAsLanding: boolean): void {
  publishBriefingGlobals();
  BriefingRoute.init();
  bindBriefingCtas(ctx);
  if (openAsLanding) BriefingRoute.open();
}

/** Publica BriefingRoute no window (lido por routeSingletonByName da topbar). */
function publishBriefingGlobals(): void {
  const win = window as unknown as BriefingPublishWindow;
  win.BriefingRoute = BriefingRoute;
}

/** Liga o card do mapa + CTAs: Explorar (mapa/botao) e Copiloto (chat). */
function bindBriefingCtas(ctx: AppContext): void {
  const openExplore = (): void => getTopbarNav()?.go('explore');
  const mapCard = qs<HTMLElement>('#briefingMapCard');
  mapCard?.addEventListener('click', openExplore);
  mapCard?.addEventListener('keydown', (event) => {
    // role="button" em div nao dispara click via teclado — Enter/Espaco manual.
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openExplore();
  });
  qs<HTMLElement>('#briefingExploreCta')?.addEventListener('click', openExplore);
  qs<HTMLElement>('#briefingCopilotCta')?.addEventListener('click', () => {
    ctx.commands.openCopilotChat('Resumo do dia: o que mudou no quadro político de Manaus?');
  });
}
